var chunkMapping = {
	"921": [
		921
	],
	"1155": [
		1155
	],
	"1693": [
		1693
	],
	"2036": [
		2036
	],
	"2198": [
		2198
	],
	"2380": [
		2380
	],
	"2522": [
		2522
	],
	"2538": [
		2538
	],
	"2803": [
		2803
	],
	"2949": [
		2949
	],
	"3531": [
		3531
	],
	"3664": [
		3664
	],
	"3683": [
		3683
	],
	"3762": [
		3762
	],
	"3771": [
		3771
	],
	"4448": [
		4448
	],
	"4547": [
		4547
	],
	"5089": [
		5089
	],
	"5119": [
		5119
	],
	"5638": [
		5638
	],
	"5649": [
		5649
	],
	"6707": [
		6707
	],
	"6729": [
		6729
	],
	"6813": [
		6813
	],
	"6966": [
		6966
	],
	"7078": [
		7078
	],
	"7360": [
		7360
	],
	"8191": [
		8191
	],
	"8787": [
		1194
	],
	"9794": [
		9794
	],
	"9913": [
		9913
	],
	"9950": [
		9950
	]
};
var idToExternalAndNameMapping = {
	"921": [
		"default",
		"./Store",
		5761
	],
	"1155": [
		"default",
		"./Investor",
		8297
	],
	"1194": [
		"default",
		"./CampaignDetails",
		8081
	],
	"1693": [
		"default",
		"./Education",
		1768
	],
	"2036": [
		"default",
		"./Search",
		8894
	],
	"2198": [
		"default",
		"./Assistant",
		1768
	],
	"2380": [
		"default",
		"./SearchJob",
		8894
	],
	"2522": [
		"default",
		"./Balance",
		6784
	],
	"2538": [
		"default",
		"./Shortener",
		2617
	],
	"2803": [
		"default",
		"./Ads",
		1527
	],
	"2949": [
		"default",
		"./StoreCart",
		5761
	],
	"3531": [
		"default",
		"./NewJob",
		1768
	],
	"3664": [
		"default",
		"./OrderSuccessful",
		5761
	],
	"3683": [
		"default",
		"./Profile",
		1768
	],
	"3762": [
		"default",
		"./EditNote",
		1768
	],
	"3771": [
		"default",
		"./Watch",
		41
	],
	"4448": [
		"default",
		"./ViewNote",
		1768
	],
	"4547": [
		"default",
		"./ProjectCategories",
		5761
	],
	"5089": [
		"default",
		"./Employment",
		1768
	],
	"5119": [
		"default",
		"./ProductDetails",
		5761
	],
	"5638": [
		"default",
		"./Business",
		1768
	],
	"5649": [
		"default",
		"./Messenger",
		7404
	],
	"6707": [
		"default",
		"./Reports",
		6784
	],
	"6729": [
		"default",
		"./Locker",
		6234
	],
	"6813": [
		"default",
		"./AllProducts",
		5761
	],
	"6966": [
		"default",
		"./Checkout",
		5761
	],
	"7078": [
		"default",
		"./Mail",
		630
	],
	"7360": [
		"default",
		"./Notes",
		1768
	],
	"8191": [
		"default",
		"./Campaigns",
		8081
	],
	"9794": [
		"default",
		"./Laboratory",
		1768
	],
	"9913": [
		"default",
		"./OrderDetails",
		5761
	],
	"9950": [
		"default",
		"./Notifications",
		4349
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}